//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate')
        .directive('socialIcon', () => ({
          restrict: 'E',
          scope: {
            muted: '=?',
            network: '@',
            large: '@',
          },
          replace: true,
          template: '<i class="social-icon fa" ng-class="[networkClass, faClass, sizeClass, mute(colorClass)]"></i>',
          controller: ['$scope',
            function($scope) {
              const network = $scope.network ? $scope.network.toLowerCase() : '';
              $scope.networkClass = network;
              $scope.sizeClass = $scope.large ? 'fa-lg' : '';
              switch (network) {
                case 'pinterest':
                  $scope.colorClass = 'pinterest-red';
                  $scope.faClass = 'fa-pinterest';
                  break;
                case 'instagram':
                  $scope.colorClass = 'instagram-blue';
                  $scope.faClass = 'fa-instagram';
                  break;
                case 'facebook':
                  $scope.colorClass = 'facebook-blue';
                  $scope.faClass = 'fa-facebook-square';
                  break;
                case 'tumblr':
                  $scope.colorClass = 'tumblr-blue';
                  $scope.faClass = 'fa-tumblr-square';
                  break;
                case 'twitter':
                  $scope.colorClass = 'twitter-blue';
                  $scope.faClass = 'fa-twitter-square';
                  break;
                default:
                  $scope.faClass = 'fa-question-circle';
                  $scope.colorClass = 'unknown-gray';
                  break;
              }

              $scope.mute = function(c) {
                return $scope.muted ? 'muted-gray' : c;
              };
            },
          ],
        }));
})();
